import { Container } from "react-bootstrap";
import { useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const HomePageAboutNewSection = () => {
    const sectionRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {

            // Initial Blur Reveal
            gsap.from(".about-line", {
                opacity: 0,
                filter: "blur(1rem)",
                duration: 1.2,
                stagger: 0.15,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 75%",
                },
            });

            // Noteworthy Style Horizontal Motion
            ScrollTrigger.create({
                trigger: sectionRef.current,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onUpdate: (self) => {
                    const move = self.progress * 2;

                    gsap.set(".line-1", {
                        xPercent: move,
                    });

                    gsap.set(".line-2", {
                        xPercent: -move,
                    });

                    gsap.set(".line-3", {
                        xPercent: move,
                    });
                },
            });

            // Blur & Fade when moving upward
            gsap.utils.toArray(".about-line").forEach((line) => {
                gsap.fromTo(
                    line,
                    {
                        opacity: 1,
                        filter: "blur(0px)",
                    },
                    {
                        opacity: 0.2,
                        filter: "blur(14px)",
                        ease: "none",
                        scrollTrigger: {
                            trigger: line,
                            start: "top 30%",
                            end: "top -20%",
                            scrub: true,
                        },
                    }
                );
            });

        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section
            className="home-page-new-about pd-common"
            ref={sectionRef}
        >
            <Container>
                <div className="about-new-content">
                    <h2 className="about-text-title">

                        <div className="about-line line-1">
                            <span className="fs-secondary">
                                Infinite Consciousness
                            </span>{" "}
                            is not a pursuit for a few,
                        </div>

                        <div className="about-line line-2">
                            but a gift available to every human being—
                        </div>

                        <div className="about-line line-3">
                            waiting to be realized, awakened, and lived through
                            purposeful <span className="fs-secondary">awareness.</span>
                        </div>

                    </h2>
                </div>
            </Container>
        </section>
    );
};

export default HomePageAboutNewSection;